// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLeaseAgreementDisplayStyles } from "@guestsupply/App/Components/Cart/CartLeaseAgreementDisplay";
import cartSummarySharedStyles from "@guestsupply/App/SharedStyles/CartSummarySharedStyles";
import { css } from "styled-components";

cartLeaseAgreementDisplayStyles.container = {
    ...cartSummarySharedStyles.container,
};
cartLeaseAgreementDisplayStyles.titleGridItem = {
    ...cartSummarySharedStyles.titleGridItem,
};
cartLeaseAgreementDisplayStyles.titleText = {
    ...cartSummarySharedStyles.titleText,
};
cartLeaseAgreementDisplayStyles.wrapper = {
    css: css`
        &:empty {
            display: none;
        }
    `,
};
cartLeaseAgreementDisplayStyles.leaseAgreementLink = {
    css: css`
        margin-left: 4px;
    `,
};
cartLeaseAgreementDisplayStyles.leaseAgreementGridItem = {
    css: css`
        padding: 9px;
    `,
};
cartLeaseAgreementDisplayStyles.leaseAgreementTypography = {
    size: 13,
    weight: "bold",
};
cartLeaseAgreementDisplayStyles.loadingOverlayStyle = {
    css: css`
        &:empty {
            display: none;
        }
    `,
};
